import script from "./ProfilePasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilePasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ProfilePasswordPage.vue?vue&type=style&index=0&id=3dcafe0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dcafe0e"]])

export default __exports__